import styled from 'styled-components';

// =============================================================================
// Estilos da tela índice de Roteirizações — variação "Linha" (densa, 1 linha
// por tripla). Tokens do DS (theme.js); âmbar de destaque = warning (#F2AF29).
// =============================================================================

const BORDER = ({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.08)';
const MUTED = ({ theme }) => theme?.colors?.textMuted ?? '#666';
const AMBER = ({ theme }) => theme?.colors?.warning ?? '#F2AF29';

// ── Breadcrumb (texto claro sobre o shell escuro) ──────────────────────────
export const Breadcrumb = styled.nav`
   display: flex;
   align-items: center;
   gap: 6px;
   font-size: 12px;
   margin-bottom: 10px;
   color: ${({ theme }) =>
      theme?.colors?.textMutedOnAppBackground ?? 'rgba(255,255,255,0.72)'};

   .sep {
      opacity: 0.5;
   }
   .current {
      color: ${({ theme }) => theme?.colors?.textOnAppBackground ?? '#fff'};
      font-weight: 600;
   }
`;

// ── Controle de ordenação (no header da section Resultados) ────────────────
export const SortControl = styled.div`
   display: flex;
   align-items: center;
   gap: 8px;
   font-size: 13px;
   color: ${MUTED};

   select {
      height: 36px;
      padding: 0 8px;
      border-radius: 10px;
      border: 1px solid ${BORDER};
      font-family: inherit;
      font-size: 13px;
      background: #fff;
   }

   button {
      height: 36px;
      width: 36px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      border: 1px solid ${BORDER};
      background: #fff;
      cursor: pointer;
      font-size: 14px;
      line-height: 1;

      &:hover {
         background: #f1f3f6;
      }
   }
`;

// ── Lista densa ─────────────────────────────────────────────────────────────
export const List = styled.div`
   display: flex;
   flex-direction: column;
`;

export const Row = styled.div`
   position: relative;
   display: flex;
   align-items: center;
   gap: 16px;
   padding: ${({ $compact }) => ($compact ? '11px 16px' : '16px')};
   border-bottom: 1px solid ${BORDER};
   cursor: pointer;

   &:last-child {
      border-bottom: none;
   }
   &:hover {
      background: #f7f9fc;
   }

   /* Faixa de acento à esquerda — só quando há pendência (total_unrouted > 0). */
   &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 3px;
      background: ${({ $pending }) => ($pending ? AMBER : 'transparent')};
   }
`;

export const RowMain = styled.div`
   display: flex;
   flex-direction: column;
   gap: 4px;
   flex: 1;
   min-width: 0;
`;

export const TripTitle = styled.div`
   display: flex;
   align-items: center;
   gap: 8px;
   flex-wrap: wrap;

   .trip {
      font-size: 15px;
      font-weight: 700;
      color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};
   }
`;

export const Meta = styled.div`
   display: flex;
   align-items: center;
   flex-wrap: wrap;
   gap: 6px;
   font-size: 12px;
   color: ${MUTED};

   .sep {
      opacity: 0.45;
   }
`;

export const Stats = styled.div`
   display: flex;
   align-items: center;
   gap: 22px;
   flex-shrink: 0;

   @media (max-width: 640px) {
      gap: 14px;
   }
`;

export const Stat = styled.div`
   display: flex;
   flex-direction: column;
   align-items: flex-end;
   line-height: 1.25;

   .v {
      font-size: 15px;
      font-weight: 700;
      font-variant-numeric: tabular-nums;
      color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};
   }
   .l {
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 0.02em;
      color: ${MUTED};
   }
`;

// Chip de destaque (pendentes): âmbar quando > 0, verde quando 0 (tudo roteirizado).
export const Chip = styled.span`
   display: inline-flex;
   align-items: center;
   padding: 4px 10px;
   border-radius: 999px;
   font-size: 12px;
   font-weight: 700;
   white-space: nowrap;
   border: 1px solid
      ${({ $done }) => ($done ? 'rgba(46,125,50,0.35)' : 'rgba(242,175,41,0.5)')};
   background: ${({ $done }) =>
      $done ? 'rgba(46,125,50,0.12)' : 'rgba(242,175,41,0.15)'};
   color: ${({ $done }) => ($done ? '#1b5e20' : '#7d5a00')};
`;

export const Chevron = styled.span`
   font-size: 18px;
   line-height: 1;
   color: ${MUTED};
   flex-shrink: 0;
`;
